<template>
	<div>
		<el-dialog title="客户申诉" :visible.sync="dialogVisible" width="500px">
			<el-form :model="form" :rules="rules" ref="formRef">
				<el-form-item prop="complaintContent">
					<el-input
						type="textarea"
						placeholder="请输入申诉内容"
						v-model="form.complaintContent"
						maxlength="50"
						show-word-limit
					/>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="cancelBtnFun">取 消</el-button>
				<el-button type="primary" @click="confirmBtnFun">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
export default {
	data() {
		return {
			dialogVisible: false,
			form: {
				orderNum: undefined,
				complaintContent: undefined,
			},
			rules: {
				complaintContent: [
					{ required: true, message: '申诉内容不能为空', trigger: 'blur' },
				],
			},
		}
	},
	methods: {
		// 打开弹框
		openDialog(orderNum) {
			this.form.orderNum = orderNum
			this.dialogVisible = true
		},
		// 取消弹框
		cancelBtnFun() {
			this.dialogVisible = false
			this.clearParams()
		},
		clearParams() {
			this.form.orderNum = undefined
			this.form.complaintContent = undefined
		},
		// 确认
		confirmBtnFun() {
			this.$refs.formRef.validate((valid) => {
				if (valid) {
					let params = {
						orderNum: this.form.orderNum,
						complaintContent: this.form.complaintContent,
					}
					this.HttpService.post(
						`/autoapp-default-server-recovery/api/user-order/complaint`,
						params
					).then((res) => {
						if (res.statusCode === 200) {
							this.$message.success("申诉提交成功");
							this.dialogVisible = false
							this.clearParams()
						} else {
							this.$message.error('已无法登记，请直接联系回收商处理！')
						}
					});
				} else {
					this.$message.warning('请填写申诉内容');
				}
			});
		},
	},
}
</script>
<style scoped lang="scss">
.dialog-footer{
	padding: 20px;
	box-sizing: border-box;
}
</style>


// WEBPACK FOOTER //
// src/views/order/components/CustomerComplainDialog.vue